 <aims-common-table
        id="pub-table"
        [dataSource]="publications | async"
        [defaultTableState] = "{ sort:{ active : 'pubNum', direction: 'asc' }}"
        [addRowInitialObject]="defaultItem"
        [header]="tableHeader"
        [permissions]="tablePermissions"
        [pageSize]="15"
        (rowUpdated)="handleRowUpdate($event)"
        (rowAdded)="handleRowAdded($event)"
        (rowDeleted)="handleRowDelete($event)"
        [stickyHeader]="true">

  <aims-common-table-dynamic-row id="pubIndexTypeId">
    <ng-template viewMode let-element >
      {{ element.pubIndexTypeId | getText:'pubIndexTypeId':'pubIndexType':pubIndexTypeValues | async }}
    </ng-template>

    <ng-template editMode let-element let-dynamicControl="dynamicControl">
      <mat-form-field appearance="fill" class="form-component" class="editable-text-field" >
        <mat-select style="width: 100px" [formControl]="dynamicControl" name="pubIndexTypeId">
          <mat-option *ngFor="let p of pubIndexTypeValues | async" [value]="p.pubIndexTypeId">
            {{ p.pubIndexType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>

    <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
      <mat-form-field appearance="fill" style="margin-top: 20px; width: 100px">
        <mat-label>Filter</mat-label>
        <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
          <mat-option label=""></mat-option>
          <mat-option *ngFor="let p of pubIndexTypeValues | async" [value]="p.pubIndexTypeId">
            {{ p.pubIndexType }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>
  </aims-common-table-dynamic-row>

</aims-common-table>
